module.exports = "/static/assets/a4df852fbca02033445630d2a39d182e.png";